import React from 'react'
import { type AsyncStatus, type Warehouse } from 'legacy/common/types'

export interface WarehousesContextValue {
  warehouses: Warehouse[]
  status: AsyncStatus
}

export const WarehousesContext = React.createContext<WarehousesContextValue | null>(null)

WarehousesContext.displayName = 'WarehousesContext'
